import { Component, Input, OnInit } from '@angular/core';
import { MyCampApp } from '../../api/common/enumerations';

@Component({
    selector: 'mycampapp-document-viewer',
    templateUrl: './document-viewer.component.html',
    styleUrls: ['./document-viewer.component.less']
})
export class DocumentViewerComponent implements OnInit
{
    DocumentType = MyCampApp.DocumentType;

    @Input() documentType!: MyCampApp.DocumentType;

    constructor()
    {
    }

    ngOnInit()
    {

    }

}
